type MenuPositionData = {
  levelTwoPosition: number;
  totalLevelTwoItems: number;
  totalLevelThreeItems: number;
};

export const MENU_HIDE_DURATION_MS = 300;
const DESKTOP_MENU_ITEM_HEIGHT_REM = 4;
export const CLUB_NAME_LENGTH_TO_REDUCE_SIZE = 15;

export const levelThreeMenuTopStyling = ({
  levelTwoPosition,
  totalLevelTwoItems,
  totalLevelThreeItems,
}: MenuPositionData) => {
  const overflowAmount = Math.max(
    0,
    levelTwoPosition + (totalLevelThreeItems - 1) - totalLevelTwoItems
  );

  const position = Math.max(1, levelTwoPosition - overflowAmount);

  return `${(position - 1) * DESKTOP_MENU_ITEM_HEIGHT_REM}rem`;
};
